import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import { dialogHeaderClasses } from './dialogHeaderClasses';

export const HeaderRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 3, 0, 3)
}));

export const TitleContainerRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(1)
}));

export const ContainerRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(3),
  top: theme.spacing(3),
  display: 'flex',
  alignItems: 'center'
}));

export const DialogTitleRoot = styled(DialogTitle, {
  name: 'AFDialogHeader'
})(({ theme }) => ({
  padding: 0,
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  [`& .${dialogHeaderClasses.helpIcon}`]: {
    display: 'flex',
    fontSize: 16,
    color: theme.palette.grey[500],
    marginLeft: theme.spacing(0.5)
  },
  [`& .${dialogHeaderClasses.badge}`]: {
    marginLeft: theme.spacing(1),
    '& .MuiBadge-badge': {
      position: 'relative',
      transform: 'none'
    }
  },
  [`& .${dialogHeaderClasses.disclaimer}`]: {
    marginRight: theme.spacing(2),
    fontWeight: 400,
    color: theme.palette.text.secondary
  },
  [`& .${dialogHeaderClasses.description}`]: {
    marginTop: theme.spacing(1),
    fontSize: 14,
    color: theme.palette.text.secondary
  },
  [`& .${dialogHeaderClasses.closeButton}`]: {
    '&.MuiIconButton-root.MuiIconButton-sizeSmall': {
      padding: 0,
      color: theme.palette.grey[600]
    }
  },
  [`& .${dialogHeaderClasses.image}`]: {
    display: 'grid',
    justifyItems: 'center',
    padding: theme.spacing(3, 0),
    '& > img': {
      weight: 260,
      height: 180
    }
  },
  [`& .${dialogHeaderClasses.actions}`]: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0, 3),
    '& .MuiTabs-flexContainer': {
      border: 'none'
    }
  }
}));
